import { render, staticRenderFns } from "./WithAddons.vue?vue&type=template&id=e388e278&"
import script from "./WithAddons.vue?vue&type=script&lang=js&"
export * from "./WithAddons.vue?vue&type=script&lang=js&"
import style0 from "./WithAddons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e388e278')) {
      api.createRecord('e388e278', component.options)
    } else {
      api.reload('e388e278', component.options)
    }
    module.hot.accept("./WithAddons.vue?vue&type=template&id=e388e278&", function () {
      api.rerender('e388e278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/WithAddons.vue"
export default component.exports